import { render, staticRenderFns } from "./StoneCladding.vue?vue&type=template&id=38ea2a8b&"
import script from "./StoneCladding.vue?vue&type=script&lang=js&"
export * from "./StoneCladding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports